module.exports = __webpack_public_path__ + "img/logo-icon-gray.4d22cfa0.svg";